<template>
	<div name="hrms-timepicker" class="box-dpk">
    <input maxlength='5' v-model="inputTime" @blur="calendarTime()" class="input-timepicker align-center"
           @keyup="calendarTime()"
           :name="name"
           :class="{ 'input-error' : hasError }"
           :disabled="disabled"
           ref="timePickerInput" />
	  <time-picker :date="date" :option="option" :disabled="disabled" @change="changeInputTime(arguments[0])"></time-picker>
	</div>
</template>

<script>
import vueTimepickerForked from 'components/vueTimepickerForked/component'

export default {
  name: 'hrms-timepicker',
  data () {
    return {
      inputTime: this.timeInputConvertFormat(this.value),
      date: {
        time: this.value
      },
      option: {
        format: 'HH:mm'
      }
    }
  },
  watch: {
    value () {
      this.date.time = this.timeInputConvertFormat(this.value)
    },
    'date.time' () {
      this.inputTime = this.date.time
      this.$emit('input', this.date.time)
    }
  },
  methods: {
    changeInputTime (data) {
      this.$emit('changeInputTime', data)
    },
    calendarTime () {
      this.date.time = this.timeInputConvertFormat(this.inputTime)
    },
    timeInputConvertFormat (timeInput) {
      // ex. timeInput = '11:50', '11.50' or '1150'
      let timeInputConverted = ''
      if (timeInput === '' || typeof timeInput === 'undefined') {
        timeInputConverted = ''
      } else {
        let timeInputReplace = timeInput.replace(':', '').replace('.', '')
        timeInputConverted = timeInputReplace.substring(0, 2).replace('24', '00') + ':' + timeInputReplace.substring(2, 4)
      }
      return timeInputConverted
    }
  },
  props: {
    value: {
      type: String,
      required: true,
      default: ''
    },
    hasError: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    name: {
      type: String,
      default: 'time'
    }
  },
  components: {
    'time-picker': vueTimepickerForked
  }
}
</script>

<style src="./style.scss" lang='scss' scoped></style>


// WEBPACK FOOTER //
// component.vue?71e2b11a